import { render, staticRenderFns } from "./InvestmentInfoBox.vue?vue&type=template&id=5cc876f5"
import script from "./InvestmentInfoBox.vue?vue&type=script&lang=js"
export * from "./InvestmentInfoBox.vue?vue&type=script&lang=js"
import style0 from "./InvestmentInfoBox.vue?vue&type=style&index=0&id=5cc876f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports